import { setConfig as coreSetConfig } from 'js/components/main/Kambi/helpers';

export const setConfig = ({ config, customerSettings, showLoginPopup, setKambiInitialized }) => {
    const { environment } = customerSettings;
    const extendedConfig = { ...config, ...{ ...environment && { environment } } };

    coreSetConfig({ config: extendedConfig, customerSettings, showLoginPopup, setKambiInitialized });
};

export { attachKambiDOM, navigateHome, detachKambiDOM, existKambiDOM } from 'js/components/main/Kambi/helpers';
